export default "__VITE_ASSET__DV9Bo57S__"